module.exports = require("./ar-KW.d.ts");